<template>
  <div>
    <div
      v-if="activityInfo"
      :class="['pullNewHelp', { inApp: $root.$data.isApp }]"
      :style="{ background: 'url(' + activityInfo.activityBackgroundPicture + ') repeat' }"
    >
      <CommonTitle :titleName="activityInfo.activityName" />
      <Banner :activityInfo="activityInfo" />
      <Rule :activityRule="activityInfo.activityRule" />

      <div>
        <Btn
          v-if="!activityInfo.isAssistanceSuccess && !userInfo.id"
          :title="activityInfo.pullNewType === 0 ? '一键帮好友助力～' : '领取课程，帮好友助力~'"
          @click.native="goToHelp"
        />
        <Btn v-else title="我也要参与活动" @click.native="goToHome" />
      </div>
      <CoursePull
        v-if="productId"
        @coursePullCb="coursePullCb"
        :productId="productId"
        type="help"
        :helpStatus="helpStatus"
        :productSkuId="productSkuId"
      />
      <Recommend :activityId="activityId" />
      <AppDown v-if="!(this.$root.ytMini || this.$root.pullNewType === 2)" />
      <ChatCommunity v-if="chatCommunityShow" :productId="productId" :productSkuId="productSkuId" />

      <van-popup
        v-model="statusPopup"
        class="statusPopup"
        :duration="0"
        :close-on-click-overlay="helpStatus === 1 || helpStatus === 3 ? false : true"
      >
        <div class="statusContent" :class="{ success: helpStatus === 1 || helpStatus === 3 }">
          <img
            class="helpStatus"
            :src="helpStatus === 1 ? successBg : helpStatus === 3 ? failBg1 : failBg"
            alt=""
          />
          <img
            class="close"
            v-if="!(helpStatus === 1 || helpStatus === 3)"
            @click="statusPopup = false"
            :src="close"
            alt=""
          />
          <p class="tips">
            {{
              helpStatus === 1
                ? '太棒啦，快来一起参与活动吧～'
                : helpStatus === 2
                ? '当前助力用户和分享用户是同一用户'
                : '话不多说，先去参与活动吧～'
            }}
          </p>
          <ExamSeason
            @closeRegisterAfter="closeRegisterAfter"
            v-show="helpStatus === 1 || helpStatus === 3"
          />
        </div>
      </van-popup>
      <van-popup
        v-model="courseSuccessPopup"
        class="courseSuccessPopup"
        :class="{ showQrcode: helpSuccessData.qrcode }"
        :duration="0"
        :close-on-click-overlay="true"
        :closeable="false"
      >
        <!-- <CourseSuccess @closeRegisterAfter="closeRegisterAfter" :qrcode="helpSuccessData.qrcode"/> -->
        <CourseSuccess @closeCourseSuccessAfter="closeCourseSuccessAfter" :qrcode="dataBags" />
      </van-popup>
    </div>
    <ExamSeason2
      :examSeasonCourseVisible="examSeasonCourseVisible"
      @closeAfter="closeAfterCourse"
    />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { getAssistanceInfoApi, assistanceApi, newAssistanceApi } from '@/api/pullNew';
// eslint-disable-next-line import/no-cycle
import { reqIsBuyProduct } from '@/api/courseDetail';
import { mapState } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import { Dialog } from 'vant';
import wx from 'weixin-js-sdk';
import loadJS from 'load-js';
import Banner from '../components/banner.vue';
import Rule from '../components/rule.vue';
import Btn from '../components/btn.vue';
import CoursePull from '../components/coursePull.vue';
import AppDown from '../components/appDown.vue';
import Recommend from '../components/recommends.vue';
import ExamSeason from '../components/examSeason.vue';
import ChatCommunity from './../components/chat';
import CourseSuccess from './../components/courseSuccess';
import ExamSeason2 from '../components/examSeason2.vue';
import { setBaseUrl, initCaptcha, triggerCaptcha, getDeviceFingerprint } from '@/utils/tools';
import { reqUserInfo } from '@/api';
import Fingerprint2 from '@fingerprintjs/fingerprintjs';

export default {
  components: {
    CommonTitle,
    Banner,
    Rule,
    Btn,
    CoursePull,
    AppDown,
    Recommend,
    ExamSeason,
    ChatCommunity,
    CourseSuccess,
    ExamSeason2,
  },
  data() {
    return {
      activityId: null,
      encryptionKey: null,
      activityInfo: null,
      helpStatus: null, // 1 助力成功 2 自己不能给自己助力 3 助力失败
      statusPopup: false, // 助力状态弹窗
      courseSuccessPopup: false, // 仅课程拉新成功时弹出
      successBg: require('@/assets/img/pullNew/success.png'),
      failBg: require('@/assets/img/pullNew/fail.png'),
      failBg1: require('@/assets/img/pullNew/fail1.png'),
      close: require('@/assets/img/pullNew/helpClose.png'),
      dataBags:
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/courseSuccess_bg_new.png',
      pullNewType: 0, // 拉新类型 0 注册拉新 1 课程拉新
      productId: null, // 课程ID
      productSkuId: null,
      helpSuccessData: {}, // 仅针对课程拉新用
      ncSuccessData: {}, // 滑块成功回调
      chatCommunityShow: false, // 页面悬浮挂件
      examSeasonCourseVisible: false, // 课程拉新，选择考季
      FingerprintData:''
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    // 滑动验证
    async pageNcActions() {
      this.assistance();
    },
    async getActivityInfo() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const info = await getAssistanceInfoApi({
        activityId: this.activityId,
        encryptionKey: this.encryptionKey,
      });
      this.$toast.clear();
      const { code, data, msg } = info;
      if (code === 0) {
        this.activityInfo = data;
        const { isAssistanceSuccess, pullNewType = 0, productId, productSkuId } = data;
        if (this.$root.$data.isApp) document.title = data.activityName;
        this.pullNewType = pullNewType;
        this.productId = productId;
        this.productSkuId = productSkuId;
        const { activityId, activityPicture, activityName } = data;
        const path = `${
          window.location.origin
        }/ark/pullnew/helper/?activityId=${activityId}&pullNewType=${
          this.$root.pullNewType === 2 ? 'yt' : ''
        }&miniSource=${this.$root.ytMini ? 'yt' : ''}`;
        this.wxInit(path, activityName, activityPicture);
        if (!isAssistanceSuccess && this.userInfo.id) {
          // 未助力 且登录状态下
          if (!this.userInfo.id) {
            window.location.reload();
            return;
          }
          triggerCaptcha();
        }
      } else if (code === 9001 || code === 9002 || code === 9408) {
        // 未开始 已结束
        this.$router.replace({
          path: '/pullnew/over',
          query: {
            activityId: this.activityId,
            activityStatus: code,
          },
        });
      } else {
        this.$toast.fail(msg);
      }
    },
    wxInit(path, title, imageUrl) {
      wx.ready(() => {
        // 需在用户可能点击分享按钮前就先调用
        wx.miniProgram.postMessage({
          data: {
            path,
            title,
            imageUrl,
          },
        });
      });
    },
    // 课程选择考季回调
    closeAfterCourse() {
      // 开始课程助力流程
      this.examSeasonCourseVisible = false;
      this.pageNcActions();
    },
    async getUserDiffTime() {
      const res = await reqUserInfo();
      const currentTime = new Date(res?.currentTime); // 当前时间
      const createTime = new Date(res?.data?.createTime); // 注册时间
      const diff = Math.abs(currentTime - createTime);
      const diffInSeconds = diff / 1000;
      console.log('+++++', diffInSeconds);
      return diffInSeconds <= 1800 && diffInSeconds >= 0;
    },
    async beforeAssistaance() {
      const isNewUser = await this.getUserDiffTime();
      console.log('+++++', isNewUser, this.pullNewType);
      if (!isNewUser && this.pullNewType === 1) {
        // 不是新用户，课程拉新直接弹出失败弹窗。
        this.helpStatus = 3;
        this.statusPopup = true;
        return;
      }
      if (isNewUser && this.pullNewType === 1) {
        // 新用户，课程拉新,弹出考级选择
        this.examSeasonCourseVisible = true;
        return;
      }
      this.pageNcActions();
    },
    // 开始助力
    async assistance() {
      // 助力接口
      const { code, data } = await newAssistanceApi({
        captchaVerifyParam: this.nvcData,
        activityId: this.activityId,
        encryptionKey: this.encryptionKey,
        sessionId: this.ncSuccessData.sessionId,
        sig: this.ncSuccessData.sig,
        token: this.ncSuccessData.token,
        ua: navigator.userAgent,
        visitorId: this.FingerprintData.visitorId,
        sceneId: 'y0p990dn',
      });
      if (code === 0) {
        this.helpSuccessData = data;
        this.helpStatus = 1;
      } else if (code === 9013) {
        // 自己给自己助力
        this.helpStatus = 2;
      } else if (code === 9014) {
        // 当前分享的活动，已到达最多拉新的人数，助力失败
        this.helpStatus = 3;
      } else {
        this.helpStatus = 4;
      }
      if (this.helpStatus === 1 && this.pullNewType === 1) {
        this.courseSuccessPopup = true;
      } else {
        this.statusPopup = true;
      }
      this.showNc = false;
    },
    async goToHelp() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('login');
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        const params = searchParams.split('&');
        const paramsMap = new Map();

        params.forEach((item) => {
          const [key, value] = item.split('=');
          if (key) {
            paramsMap.set(key, value);
          }
        });
        const entries = paramsMap.entries();
        let query = '';
        const ExcludequeryArr = ['THIRD_SESSION', 'env'];
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of entries) {
          if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
        }
        url = `${domain}?${query}`;
        const redirctUrl = encodeURIComponent(
          `/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else {
        const { path, query } = this.$route;
        this.$router.push({
          path: '/registrationLogin',
          query: {
            redirect: path,
            loginSource: this.$root.pullNewType === 2 ? 'yuntulogin' : '',
            ...query,
          },
        });
      }
    },
    async goToCourse() {
      const { code, data } = await reqIsBuyProduct(this.productId);
      if (code !== 0 || !data.length) {
        this.$toast.fail('课程发放中，请稍后再试');
        return;
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(this.productId), false);
        return;
      }
      sessionStorage.setItem('back', 'back');
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: this.productId,
        },
      });
    },
    async goToHome() {
      this.$router.push({
        path: '/pullnew/home',
        query: {
          activityId: this.activityId,
          pullNewType: this.$root.pullNewType === 2 ? 'yt' : '',
        },
      });
    },
    closeCourseSuccessAfter() {
      window.location.href = `${setBaseUrl('')}/iform/index/69`;
    },
    closeRegisterAfter() {
      this.statusPopup = false;
      this.courseSuccessPopup = false;
    },
    // 从CoursePull组件反馈过来的信息
    coursePullCb() {
      this.chatCommunityShow = true;
    },
    navCallback(data) {
      this.nvcData=data;
      this.beforeAssistaance();
    },
  },
  async mounted() {
    Fingerprint2.load().then((res)=>{
      res.get().then((data)=>{
        this.FingerprintData=data
      })
    })

    initCaptcha('y0p990dn', this.navCallback);
    this.getActivityInfo();
    if (this.$root.ytMini || this.$root.pullNewType === 2) {
      document.title = '云图书吧';
    }
  },
  created() {
    const { activityId, key } = this.$route.query;
    this.activityId = activityId;
    this.encryptionKey = key;
  },
};
</script>
<style scoped lang="scss">
.nc-box {
  position: relative;
  width: 670px;
  height: 260px;
  padding-top: 50px;
  text-align: center;
  background: #fff;
  .nc-close {
    position: absolute;
    top: 20px;
    right: 30px;
    width: 36px;
    height: 36px;
  }
  .nc-desc {
    font-size: 28px;
    text-align: center;
  }
  .nc-content-box {
    box-sizing: border-box;
    width: 100%;
    margin-top: 48px;
  }
}
.pullNewHelp {
  min-height: 100vh;
  padding: 100px 0;

  &.inApp {
    padding-top: 0;
  }

  .statusPopup {
    background: none;

    .statusContent.success {
      height: 1028px;

      .tips {
        bottom: 550px;
      }
    }

    .statusContent {
      position: relative;
      width: 622px;
      height: 548px;

      .helpStatus {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .close {
        position: absolute;
        top: 20px;
        right: 0;
        width: 48px;
        height: 48px;
      }

      .tips {
        position: absolute;
        bottom: 70px;
        width: 100%;
        color: #733d08;
        font-size: 28px;
        text-align: center;
      }
    }
  }

  .courseSuccessPopup {
    box-sizing: border-box;
    width: 622px;
    height: 846px;
    font-size: 28px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/courseSuccessBg3.png')
      no-repeat;
    background-size: 100%;
    border-radius: 32px;

    h5 {
      color: #333;
      font-size: 36px;
      text-align: center;
    }

    p {
      width: 100%;
      padding: 48px 0 24px 0;
      text-align: center;
      // border-bottom: 2px solid #ebebeb;
    }

    .examSeason {
      position: relative;
      top: 0;
      // top: 300px;
    }

    .info {
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      padding: 0 32px;
    }

    .slogan {
      box-sizing: border-box;
      width: 374px;
      margin-left: 10px;
      // margin-top: 32px;
      padding: 0 0 0 24px;
      // overflow-x: scroll;
      color: #333;
    }

    .groupImg {
      width: 160px;
      // height: 160px;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 462px;
      height: 88px;
      margin-top: 10px;
      color: #fff;
      background: #ff1a3f;
      border-radius: 44px;
    }
  }
  .courseSuccessPopup.showQrcode {
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/courseSuccessBg3.png')
      no-repeat;
    background-size: 100%;
  }

  ::v-deep .van-overlay,
  ::v-deep .van-popup--center {
    z-index: 1000000 !important;
  }
}
</style>
<style>
.sm-pop-inner.nc-container {
  width: 80%;
}
</style>
